import RideResource from "./ride.resource";

const rideModule = angular
  .module("app.resources.ride", [])
  .service("Ride", RideResource);

export default rideModule;



// WEBPACK FOOTER //
// ./src/resources/ride/ride.module.js